import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $locationCollapse: this.el._$('.homepage-masthead__collapsible'),
      $locationContent: this.el._$('.homepage-masthead__collapsible-content')
    };

    // open by default
    this.handleCollapse();
  }

  addListeners() {
      this.dom.$locationCollapse.addEventListener('click', this.handleCollapse.bind(this));
  }

  handleCollapse(){
    this.dom.$locationCollapse.classList.toggle('active');
    if (this.dom.$locationContent.style.display === 'block') {
      this.dom.$locationContent.style.display = 'none';
      this.dom.$locationContent.setAttribute('aria-hidden', 'true');
    } else {
      this.dom.$locationContent.style.display = 'block';
      this.dom.$locationContent.setAttribute('aria-hidden', 'false');
    }
  }
}

export default Module;
